function swiperInitHandler(swiperElement, options) {
  const swiper = new Swiper(swiperElement, options);
}

const productSwipers = document.querySelectorAll('.product__recommended-products.swiper');
productSwipers.forEach(swiperElement => {
  swiperInitHandler(swiperElement, {
    spaceBetween: 16,
    speed: 500,
    breakpoints: {
      1: {
        slidesPerView: 1
      },
      767: {
        slidesPerView: 2
      },
      1024: {
        slidesPerView: 3,
      }
    }
  })
});

const videoSwipers = document.querySelectorAll('.video__slider-swiper.swiper');
videoSwipers.forEach(swiperElement => {
  swiperInitHandler(swiperElement, {
    slidesPerView: 4,
    spaceBetween: 12,
    speed: 500,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      1: {
        slidesPerView: 1
      },
      550: {
        slidesPerView: 2
      },
      768: {
        slidesPerView: 3
      },
      1100: {
        slidesPerView: 4
      }
    }
  })
});